import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Table_Configuration } from './table';
import { TABLE_COLUMN_TYPE_ENUM } from './table.enum';
import { KeyValueString } from '../../../common/common-entities/entity';
import { AppUrlConstant } from '../../../constant/app-url';
import { Pagination } from '../pagination/pagination';
import { TableService } from './table.service';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrl: './table.component.scss',
    providers: [TableService],
})
export class TableComponent implements OnChanges {
    @Input() tableContent!: any;
    @Input() tableConfiguration!: Table_Configuration[];
    @Input() pagination!: Pagination;
    @Input() customTableClass: string = '';
    @Output() onCrudOperationClick = new EventEmitter<{ key: string; record: Object }>();
    @Output() onTableCellClick = new EventEmitter<{ key: string; record: Object }>();
    @Output() changePagination = new EventEmitter<Pagination>();
    tableHeader!: string[];
    columnTypeEnum = TABLE_COLUMN_TYPE_ENUM;

    ngOnChanges(): void {
        if (this.tableConfiguration) {
            this.tableHeader = this.tableService.createHeaderList(this.tableConfiguration);
        }
    }

    actionList: KeyValueString[] = [
        // { key: AppUrlConstant.EDIT_OPERATION, value: 'Edit' },
        { key: AppUrlConstant.VIEW_OPERATION, value: 'View' },
        // { key: AppUrlConstant.DELETE_OPERATION, value: 'Delete' },
    ];

    constructor(private tableService: TableService) {}

    setStatusName(headerName: string, columnType: string, contentValue: boolean | string) {
        if (columnType !== 'column_with_chip') {
            return { status: '', chipColorClass: '' };
        } else {
            return this.tableService.set_Chip_Color_Name_Listing(headerName, contentValue);
        }
    }

    emitCrudOperation(key: string, recordDetail: Object) {
        this.onCrudOperationClick.emit({ key, record: recordDetail });
    }

    emitCellClick(key: string, thatClickRowDetails: any) {
        this.onTableCellClick.emit({ key, record: thatClickRowDetails });
    }
}
